// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* D2Tally Styles */

/* Ensure light mode only */
html {
  color-scheme: light;
}

/* Disable dark mode media query override */
@media (prefers-color-scheme: dark) {
  html {
    color-scheme: light;
  }
}

/* Custom scrollbar for webkit browsers */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Focus visible styles */
*:focus-visible {
  outline: 2px solid #0f766e;
  outline-offset: 2px;
}

/* Selection color */
::selection {
  background-color: #ccfbf1;
  color: #0f172a;
}

/* Smooth transitions globally */
* {
  transition-property: background-color, border-color, color, opacity;
  transition-duration: 150ms;
  transition-timing-function: ease-in-out;
}

/* But not for layout properties */
*:not(.animate-*) {
  transition-property: background-color, border-color, color, opacity, box-shadow;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,yCAAyC;AACzC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,mEAAmE;EACnE,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA,kCAAkC;AAClC;EACE,+EAA+E;AACjF","sourcesContent":["/* D2Tally Styles */\n\n/* Ensure light mode only */\nhtml {\n  color-scheme: light;\n}\n\n/* Disable dark mode media query override */\n@media (prefers-color-scheme: dark) {\n  html {\n    color-scheme: light;\n  }\n}\n\n/* Custom scrollbar for webkit browsers */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Focus visible styles */\n*:focus-visible {\n  outline: 2px solid #0f766e;\n  outline-offset: 2px;\n}\n\n/* Selection color */\n::selection {\n  background-color: #ccfbf1;\n  color: #0f172a;\n}\n\n/* Smooth transitions globally */\n* {\n  transition-property: background-color, border-color, color, opacity;\n  transition-duration: 150ms;\n  transition-timing-function: ease-in-out;\n}\n\n/* But not for layout properties */\n*:not(.animate-*) {\n  transition-property: background-color, border-color, color, opacity, box-shadow;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
